// extracted by mini-css-extract-plugin
module.exports = {"resourceLink":"style-module__resourceLink___24Baa","assignmentInput":"style-module__assignmentInput___1LM_-"};